var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongRenyuan3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.758 5.5a.5.5 0 000 1v-1zm2.667 1a.5.5 0 100-1v1zm-2.667 0h2.667v-1h-2.667v1zM12.758 7.5a.5.5 0 000 1v-1zm1.667 1a.5.5 0 100-1v1zm-1.667 0h1.667v-1h-1.667v1zM5 10h5V9H5v1zm7.5 2.5v.5h1v-.5h-1zm-.5 1H3v1h9v-1zM2.5 13v-.5h-1v.5h1zm.5.5a.5.5 0 01-.5-.5h-1A1.5 1.5 0 003 14.5v-1zm9.5-.5a.5.5 0 01-.5.5v1a1.5 1.5 0 001.5-1.5h-1zM10 10a2.5 2.5 0 012.5 2.5h1A3.5 3.5 0 0010 9v1zM5 9a3.5 3.5 0 00-3.5 3.5h1A2.5 2.5 0 015 10V9z",
    fill: "#3F465C"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 5,
    r: 2.5,
    stroke: "#3F465C"
  })));
}
export default __webpack_public_path__ + "static/tongyong_renyuan3.6649aa94.svg";
export { SvgTongyongRenyuan3 as ReactComponent };